import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1000px;
  background-color: ${({ theme }) => theme.palette.primary.background};
  padding: 0 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0;
    width: 100vw;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 630px 1fr;
  gap: 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AdHeaderActions = styled.div`
  display: flex;
  gap: 25px;
`;

export const AdViewMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 5px;
    margin-bottom: 5px;
  }
`;
